export const resetButtonStyles: React.CSSProperties = {
  appearance: 'none',
  background: 'transparent',
  color: 'inherit',
  border: 'none',
  margin: 0,
  padding: 0,
  fontFamily: 'inherit',
};

export const resetListStyles: React.CSSProperties = {
  padding: 0,
  margin: 0,
};
